import toast from 'react-hot-toast'
import { useAppDispatch } from '../../reducers/store'
import adversariesStructure from './adversaries_structure.json'
import imageMapping from './imageMapping'
import AdversaryCard from './AdversaryCard'
import { downloadReportPdf } from '../../reducers/adversaries'
import { DEFAULT_TOAST_CONFIG } from '../toast/consts'

type ReportName = keyof typeof imageMapping

function AdversariesWrapper() {
  const di = useAppDispatch()

  const adversariesWithImages = adversariesStructure.map((adversaryGroup) => ({
    ...adversaryGroup,
    reports: adversaryGroup.reports.map((report) => ({
      ...report,
      reportImage:
        (report.reportName as ReportName) in imageMapping
          ? imageMapping[report.reportName as ReportName]
          : report.reportImage,
    })),
  }))

  const downloadAdversaryReport = async (reportName: string) => {
    const bucket = import.meta.env.VITE_ADVERSARY_BUCKET
    const downloaded = await di(downloadReportPdf(bucket, reportName))
    downloaded
      ? toast.success('Report successfully downloaded', DEFAULT_TOAST_CONFIG)
      : toast.error('Failed to download report, please try again', DEFAULT_TOAST_CONFIG)
  }

  return (
    <>
      <div className="absolute top-18 left-52 rounded-tl-lg border-mainBorder border-t border-l bg-contentBackground w-[calc(100%_-_208px)] h-[calc(100%_-_74px)] p-9 overflow-y-auto">
        <div className="mx-auto max-w-[924px]">
          {adversariesWithImages.map((adversaryGroup) => (
            <div className="mb-6" key={adversaryGroup.sectionName}>
              <p className="text-lg font-medium">{adversaryGroup.sectionName}</p>
              <div className="grid grid-cols-2 gap-3 mt-3">
                {adversaryGroup.reports.map((report) => (
                  <AdversaryCard
                    reportName={report.reportName}
                    reportImage={report.reportImage}
                    execSummary={report.execSummary}
                    downloadLink={report.downloadLink}
                    downloadTitle="Download Profile"
                    downloadAction={downloadAdversaryReport}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default AdversariesWrapper
